import React, {useEffect, useState} from "react";
import Header from "components/atoms/Header";
import SideBar from "components/atoms/SideBar";
import {Wrapper} from "styles/helpers.styles";
import {useLocation} from "react-router-dom";

const Layout = ({children}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const noLayout = [
        "/",
        "/signup",
        "/reset-password",
        "/email-otp",
        "/business-setup",
        "/thank-you",
        "/change-password",
        "/signup-verify-otp",
    ];
    const location = useLocation();
    const layoutNotShown = noLayout.includes(location.pathname);

    useEffect(() => {
        const checkCollapsed = () => {
            setIsCollapsed(document.body.classList.contains("collapsed"));
        };

        checkCollapsed();
        const observer = new MutationObserver(checkCollapsed);
        observer.observe(document.body, {attributes: true, attributeFilter: ["class"]});

        return () => observer.disconnect();
    }, []);
    return (
        <Wrapper $isCollapsed={isCollapsed}>
            {!layoutNotShown ? (
                <>
                    <Header />
                    <SideBar />
                    <div className="layout-wrapper">{children}</div>
                </>
            ) : (
                <div>{children}</div>
            )}
        </Wrapper>
    );
};

export default Layout;
